import React from 'react'
import { formatMoney } from '../../lib/utils'

interface MoneyCellProps {
  amount: number | null | undefined
  currency?: string
  showSign?: boolean
  colorize?: boolean
}

const MoneyCell: React.FC<MoneyCellProps> = ({
  amount,
  currency = 'THB',
  showSign = false,
  colorize = false,
}) => {
  if (amount == null || !Number.isFinite(Number(amount))) return <span className="text-gray-300">—</span>
  const formatted = formatMoney(Math.abs(amount), currency)
  const isNegative = amount < 0

  let colorClass = 'text-gray-900'
  if (colorize) {
    colorClass = isNegative ? 'text-red-600 font-medium' : 'text-green-600 font-medium'
  }

  const sign = showSign ? (isNegative ? '−' : '+') : isNegative ? '−' : ''

  return (
    <span className={`font-mono ${colorClass}`}>
      {sign}
      {formatted}
    </span>
  )
}

export default MoneyCell
